import React from "react";
import { Link } from "react-router-dom";

export default function MerchantRegisterPage() {
  const [formState, setFormState] = React.useState({
    account: "",
    password: "",
    merchantName: "",
    contactName: "",
    phoneNumber: "",
    settlementEmails: "",
    bankName: "",
    bankAccount: "",
  });
  const [isLoading, setIsLoading] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");

  function updateField(fieldName, value) {
    setFormState(function applyChange(currentState) {
      return {
        ...currentState,
        [fieldName]: value,
      };
    });
  }

  async function handleSubmit(event) {
    event.preventDefault();
    setIsLoading(false);
    setErrorMessage("Merchant self-registration is unavailable until the production registration API is connected.");
  }

  return (
    <div className="merchant-shell merchant-login-shell">
      <div className="merchant-login-wrap">
        <div className="merchant-login-brand">
          <div className="merchant-logo-mark">UW</div>
          <div className="merchant-login-brand-name">Uniweb Pte. Ltd.</div>
          <div className="merchant-login-brand-tag">Merchant Registration</div>
        </div>
        <form className="merchant-login-card merchant-register-card" onSubmit={handleSubmit}>
          <div className="merchant-login-title">Create your merchant account</div>
          <div className="merchant-login-subtitle">
            Merchant self-registration is unavailable until the production registration API is connected.
          </div>
          {errorMessage ? (
            <div className="merchant-login-error">{errorMessage}</div>
          ) : null}
          <div className="merchant-form-grid">
            <div className="merchant-form-group">
              <label className="merchant-form-label" htmlFor="merchant-register-account">
                Account
              </label>
              <input
                id="merchant-register-account"
                className="merchant-form-input"
                value={formState.account}
                onChange={function handleChange(event) {
                  updateField("account", event.target.value);
                }}
                required
              />
            </div>
            <div className="merchant-form-group">
              <label className="merchant-form-label" htmlFor="merchant-register-password">
                Password
              </label>
              <input
                id="merchant-register-password"
                className="merchant-form-input"
                type="password"
                value={formState.password}
                onChange={function handleChange(event) {
                  updateField("password", event.target.value);
                }}
                required
              />
            </div>
            <div className="merchant-form-group">
              <label className="merchant-form-label" htmlFor="merchant-register-name">
                Merchant Name
              </label>
              <input
                id="merchant-register-name"
                className="merchant-form-input"
                value={formState.merchantName}
                onChange={function handleChange(event) {
                  updateField("merchantName", event.target.value);
                }}
                required
              />
            </div>
            <div className="merchant-form-group">
              <label className="merchant-form-label" htmlFor="merchant-register-contact">
                Contact Name
              </label>
              <input
                id="merchant-register-contact"
                className="merchant-form-input"
                value={formState.contactName}
                onChange={function handleChange(event) {
                  updateField("contactName", event.target.value);
                }}
                required
              />
            </div>
            <div className="merchant-form-group">
              <label className="merchant-form-label" htmlFor="merchant-register-phone">
                Phone Number
              </label>
              <input
                id="merchant-register-phone"
                className="merchant-form-input"
                value={formState.phoneNumber}
                onChange={function handleChange(event) {
                  updateField("phoneNumber", event.target.value);
                }}
              />
            </div>
            <div className="merchant-form-group">
              <label className="merchant-form-label" htmlFor="merchant-register-settlement-emails">
                Settlement Emails
              </label>
              <input
                id="merchant-register-settlement-emails"
                className="merchant-form-input"
                value={formState.settlementEmails}
                onChange={function handleChange(event) {
                  updateField("settlementEmails", event.target.value);
                }}
              />
            </div>
            <div className="merchant-form-group">
              <label className="merchant-form-label" htmlFor="merchant-register-bank-name">
                Bank Name
              </label>
              <input
                id="merchant-register-bank-name"
                className="merchant-form-input"
                value={formState.bankName}
                onChange={function handleChange(event) {
                  updateField("bankName", event.target.value);
                }}
              />
            </div>
            <div className="merchant-form-group">
              <label className="merchant-form-label" htmlFor="merchant-register-bank-account">
                Bank Account
              </label>
              <input
                id="merchant-register-bank-account"
                className="merchant-form-input"
                value={formState.bankAccount}
                onChange={function handleChange(event) {
                  updateField("bankAccount", event.target.value);
                }}
              />
            </div>
          </div>
          <button className="merchant-login-button" type="submit" disabled={isLoading}>
            Request Access
          </button>
          <div className="merchant-login-alt-action">
            Already have an account? <Link to="/login">Back to sign in</Link>
          </div>
        </form>
        <div className="merchant-login-meta">
          Registration will only be enabled after it is connected to the production merchant API.
        </div>
      </div>
    </div>
  );
}
